import { FormattedMessage } from 'react-intl';

import { FilterSeparator, FilterWidget } from '@sorare/core/src/lib/filters';
import { filters } from '@sorare/core/src/lib/glossary';

import { RefinePrice } from './RangeSlider';
import { RefineBundledSale, RefineRarity } from './RefineList';
import { RefineSettlementWallets } from './RefineSettlementWallets';
import { WatchlistFilter } from './WatchlistFilter';

export const RarityGroup = {
  slug: 'rarity',
  filters: [RefineRarity],
};

export const PriceGroup = {
  slug: 'price',
  filters: [RefinePrice({ startsOpen: true })],
};

export const SaleGroup = {
  slug: 'sale',
  title: <FormattedMessage id="cardFilters.sale.title" defaultMessage="Sale" />,
  filters: [RefineBundledSale],
};

export const AcceptedCurrencyGroup = {
  slug: 'accepted-currency',
  title: <FormattedMessage id="cardFilters.sale.title" defaultMessage="Sale" />,
  filters: [RefineSettlementWallets],
};
export const CollectibleGroup = (f: (FilterWidget | FilterSeparator)[]) => ({
  slug: 'collectibles',
  title: (
    <FormattedMessage
      id="cardFilters.collectibles.title"
      defaultMessage="Collectibles"
    />
  ),
  filters: f,
});

export const WatchlistGroup = {
  slug: 'watchlist',
  title: <FormattedMessage {...filters.watchlist} />,
  filters: [WatchlistFilter],
};
